import { render, staticRenderFns } from "./expense-release-record.vue?vue&type=template&id=022c015a&scoped=true"
import script from "./expense-release-record.vue?vue&type=script&lang=js"
export * from "./expense-release-record.vue?vue&type=script&lang=js"
import style0 from "./expense-release-record.vue?vue&type=style&index=0&id=022c015a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c015a",
  null
  
)

export default component.exports